import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import {
  MYACCOUNT_REQUESTING,
  MYACCOUNT_POST_REQUESTING,
  MYACCOUNT_GET_PROFILE_API,
  MYACCOUNT_POST_PROFILE_API,
} from './constants'

import {
  myaccountRequestSuccess,
  myaccountRequestError,
  myaccountPostSuccess,
  myaccountPostError,
} from './actions'

const getProfileState = state => state.profile;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function myaccountsRequestApi () {
  const request = axiosApi().get(MYACCOUNT_GET_PROFILE_API)
  return handleRequest(request);
}

function myaccountsPosttApi (formData) {
  const request = axiosApi().post(
    MYACCOUNT_POST_PROFILE_API, 
    formData
  )

  return handleRequest(request);
}

function* myaccountsRequestFlow () {
  try {
    // call to our myaccountsRequestApi function with the client
    const results = yield call(myaccountsRequestApi)
    // dispatch the action with our widgets!
    yield put(myaccountRequestSuccess(results.info))

  } catch (error) {
    yield put(myaccountRequestError(error))
  }
}

function* myaccountsPostFlow () {
  const profile = yield select(getProfileState);
  try {
    // call to our myaccountsRequestApi function with the client
    const results = yield call(myaccountsPosttApi, profile.postData);
    
    // dispatch the action with our widgets!
    yield put(myaccountPostSuccess(results))

  } catch (error) {
    yield put(myaccountPostError(error))
  }
}

function* myaccountsWatcher () {
  // each of the below RECEIVES the action from the .. action
  yield [
    takeLatest(MYACCOUNT_REQUESTING, myaccountsRequestFlow),
    takeLatest(MYACCOUNT_POST_REQUESTING, myaccountsPostFlow),
  ]
}

export default myaccountsWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/MyAccount/sagas.js